@if (showSpinner) {
  <app-loader> </app-loader>
}


<div class="main-wrapper">
  <div class="outer-wrapper">
    <div class="inner-section-mian">
      <div class="user-view-header-view">
        <div class="bacnk-buuton">
          <div class="common-button" role="button" (click)="goBack()">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 6H1M1 6L5.5 10.5M1 6L5.5 1.5" stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="header-content-section">
          <h1>
            @if ((userData?.department)  ) {
            {{ userData.department }}
            } @else {
            <div class="skeleton"></div>
            }
          </h1>

          <p>
            @if (userData?.description) {
            {{ userData.description }}
            } @else {
          <div class="skeleton"></div>
          }
          </p>

          <div class="user-status-section">
            <div class="campus-section">
              <div class="campus-logo">
                <img src="../../../assets/theme1/kodex-logo.svg" alt="logo missing" />
              </div>
              <div class="campus-detail">
                <h1>
                  <span>Branch</span>

                  @if (userData?.organization) {
                  {{userData?.organization?.name}}
                  } @else {
                  <div class="skeleton branch-name-skeliton"></div>
                  }
                </h1>

              </div>
            </div>
            <div class="campus-section">
              <div class="common-button status-sect">
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13 6.00065L8.33333 1.33398V4.00065H1.53333C1.34665 4.00065 1.25331 4.00065 1.182 4.03698C1.11928 4.06894 1.06829 4.11993 1.03633 4.18265C1 4.25396 1 4.3473 1 4.53398V7.46732C1 7.654 1 7.74734 1.03633 7.81865C1.06829 7.88137 1.11928 7.93236 1.182 7.96432C1.25331 8.00065 1.34665 8.00065 1.53333 8.00065H8.33333V10.6673L13 6.00065Z"
                    stroke="#0A758C" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

              </div>
              <div class="campus-detail">
                <h1>
                  <span>Status</span>

                  @if (userData?.employee_status) {
                  {{userData?.employee_status}}
                  } @else {
                  <div class="skeleton"></div>
                  }
                </h1>
              </div>
            </div>

          </div>


        </div>
        <div class="action-buttons">
          @if (isavailablefeature('isUpdateUser') && actionView) {
          <div class="common-button edit-case" (click)="UserUpdate(userData?.uuid)">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.25 2.99919H5.1C3.83988 2.99919 3.20982 2.99919 2.72852 3.24443C2.30516 3.46014 1.96095 3.80435 1.74524 4.22772C1.5 4.70902 1.5 5.33908 1.5 6.59919V12.8992C1.5 14.1593 1.5 14.7894 1.74524 15.2707C1.96095 15.694 2.30516 16.0382 2.72852 16.254C3.20982 16.4992 3.83988 16.4992 5.1 16.4992H11.4C12.6601 16.4992 13.2902 16.4992 13.7715 16.254C14.1948 16.0382 14.539 15.694 14.7548 15.2707C15 14.7894 15 14.1593 15 12.8992V9.74919M5.99998 11.9992H7.25589C7.62277 11.9992 7.80622 11.9992 7.97885 11.9577C8.1319 11.921 8.27822 11.8604 8.41243 11.7782C8.5638 11.6854 8.69352 11.5557 8.95294 11.2963L16.125 4.12419C16.7463 3.50287 16.7463 2.49551 16.125 1.87419C15.5037 1.25287 14.4963 1.25287 13.875 1.87419L6.70293 9.04625C6.4435 9.30568 6.31378 9.43539 6.22102 9.58677C6.13878 9.72098 6.07817 9.86729 6.04143 10.0203C5.99998 10.193 5.99998 10.3764 5.99998 10.7433V11.9992Z"
                stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>

          <div class="common-button quick-case" data-toggle="modal" data-target="#quickEditModal">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.75 12.125H2.625M4.875 8H1.5M6.75 3.875H3M12.75 1.25L7.80267 8.17626C7.5837 8.48282 7.47421 8.6361 7.47895 8.7639C7.48308 8.87516 7.53643 8.97884 7.62457 9.04686C7.72581 9.125 7.91418 9.125 8.29091 9.125H12L11.25 14.75L16.1973 7.82374C16.4163 7.51718 16.5258 7.3639 16.521 7.2361C16.5169 7.12484 16.4636 7.02116 16.3754 6.95314C16.2742 6.875 16.0858 6.875 15.7091 6.875H12L12.75 1.25Z"
                stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          }


          @if (isavailablefeature('isDeleteUser') && actionView) {
          <div class="common-button delete-case" (click)="deleteModal(userData)" data-toggle="modal" data-target="#deleteModal">
            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11 4.5V3.9C11 3.05992 11 2.63988 10.8365 2.31901C10.6927 2.03677 10.4632 1.8073 10.181 1.66349C9.86012 1.5 9.44008 1.5 8.6 1.5H7.4C6.55992 1.5 6.13988 1.5 5.81901 1.66349C5.53677 1.8073 5.3073 2.03677 5.16349 2.31901C5 2.63988 5 3.05992 5 3.9V4.5M1.25 4.5H14.75M13.25 4.5V12.9C13.25 14.1601 13.25 14.7902 13.0048 15.2715C12.789 15.6948 12.4448 16.039 12.0215 16.2548C11.5402 16.5 10.9101 16.5 9.65 16.5H6.35C5.08988 16.5 4.45982 16.5 3.97852 16.2548C3.55516 16.039 3.21095 15.6948 2.99524 15.2715C2.75 14.7902 2.75 14.1601 2.75 12.9V4.5"
                stroke="#FF3532" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          }

        </div>
      </div>
      <div class="user-view-body">
       

        <app-user-detail-info class="right-main-wrapper" [userData]="userData" [actionView]="actionView" [isLoading]="isLoading" (loadingChange)="showSpinner = $event" (profileUpdated)="reloadUserData()"></app-user-detail-info>
        <app-user-detail-count class="left-main-wrapper" [userData]="userData" [actionView]="actionView"  [isLoading]="isLoading" (downloadPDFStart)="setLoading(true)" (downloadPDFEnd)="setLoading(false)" ></app-user-detail-count>

      </div>
       
    </div>


    <!-- qick Edit Modal -->
    <div class="modal fade" id="quickEditModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content custom-edit-modal-content">
          <div class="custom-modal-header">
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
            
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_11052_9144)">
                  <path d="M15 1L5 11M5 1L15 11" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <filter id="filter0_d_11052_9144" x="0" y="0" width="20" height="20" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11052_9144" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11052_9144" result="shape" />
                  </filter>
                </defs>
              </svg>
            
            </button>
          </div>
          <div class="modal-header modal-buttons-header">
            <h5 class="modal-title qiuck-modal-header">Quick actions</h5>
            <p class="custom-modal-para">Select the action you’d like to perform from the options 
            below to continue</p>
          </div>

          <div class="action-buttons-new">
            <div class="action-row top">
             
              <div data-toggle="modal" data-target="#updatePassword" data-dismiss="modal">
                <img class="image-action-row" src="../../../assets/theme1/password.png">
                <span class="txt-action-row">Password</span>
              </div>
              <div data-toggle="modal" data-target="#updateAccountNo" data-dismiss="modal">
                <img class="image-action-row" src="../../../assets/theme1/bank.png">
                <span class="txt-action-row">Bank account</span>
              </div>
              <div data-toggle="modal" data-target="#updateSalary" data-dismiss="modal">
                <img class="image-action-row" src="../../../assets/theme1/salry.png">
                <span class="txt-action-row">Salary</span>
              </div>
               <div data-toggle="modal" data-target="#updateStatus" data-dismiss="modal">
                <img class="image-action-row" src="../../../assets/theme1/status.png">
                <span class="txt-action-row">Status</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Salary update -->
    <div class="modal fade hidecolor" id="updateSalary" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog model-main modal-dialog-centered " role="document">
        <div class="modal-content ">
          <form #salaryUpdate="ngForm" (ngSubmit)="updateSalary(salaryUpdate)">
            <div class="modal-btn modal-header modal-buttons-header sub-modal-header">
              <img src="../../../assets/theme1/salry.png">
              <h5 class="modal-title" id="updateSalarylabel">Edit User Salary</h5>
            </div>
            <div class="modal-body d-flex flex-wrap justify-content-center">
              <div class="col-8 mt-2 mb-2 select-box">
                <input type="text" name="salary" [ngModel]="(userData != null) ? userData?.basic_salary : null"
                  id="salary" placeholder="Monthly Salary*" class="form-control pl-4" ngModel #salary="ngModel"
                  readonly />
              </div>
              <div class="col-8 mt-2 mb-2 select-box">
                <input type="text" name="newSalary" id="newSalary" placeholder="Enter New Salary Here*"
                  class="form-control pl-4" ngModel #salary="ngModel" />
              </div>
              <div class="col-8 mt-2 mb-2 select-box">
                <input type="text" name="salaryTax" id="salaryTax" placeholder="Enter Salary Tax Here*"
                  class="form-control pl-4" ngModel #salaryTax="ngModel" />
              </div>
            </div>
            <div class="modal-footer sub-modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Account No update -->
    <div class="modal fade hidecolor" id="updateAccountNo" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog model-main modal-dialog-centered " role="document">
        <div class="modal-content ">
          <form #accountUpdate="ngForm" (ngSubmit)="updateAccount(accountUpdate)">
            <div class="modal-btn modal-header modal-buttons-header sub-modal-header">
              <img src="../../../assets/theme1/bank.png">
              <h5 class="modal-title" id="updateAccountNo">Edit Account No</h5>
            </div>
            <div class="modal-body d-flex flex-wrap justify-content-center">
              <div class="col-8 mt-2 mb-2 select-box">
                <input type="text" name="ac_number" [ngModel]="(userData != null) ? userData?.ac_number : null"
                  (input)="restrictInputToAccounts($event)" id="ac_number" placeholder="Meezan Bank Account#*"
                  class="form-control pl-4  no-spin-arrows" ngModel #ac_number="ngModel" required />
                @if(ac_number.touched && ac_number.invalid){
                <div class="text-danger pl-3 mt-2">
                  i.e. 0000-0000000000
                </div>
                }

              </div>
            </div>
            <div class="modal-footer sub-modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- password Model -->
    <div class="modal fade hidecolor" id="updatePassword" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog model-main modal-dialog-centered " role="document">
        <div class="modal-content">
          <form #passwordUpdate="ngForm" (ngSubmit)="updatePassword(passwordUpdate)">
            <div class="modal-btn modal-header modal-buttons-header sub-modal-header">
              <img src="../../../assets/theme1/password.png">
              <h5 class="modal-title" id="updatePasswordLabel">Edit User Password</h5>
            </div>

            <div class="modal-body d-flex flex-wrap justify-content-center">
              <div class="col-8 mt-2 mb-2 select-box">
                <input type="text" inputmode="none" name="password" id="password" placeholder="Enter New Password"
                  class="form-control pl-4 " ngModel required />
              </div>
            </div>
            <div class="modal-footer sub-modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>

        </div>
      </div>
    </div>


    <!-- status update -->
    <div class="modal fade hidecolor" id="updateStatus" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog model-main modal-dialog-centered" role="document">

        <div class="modal-content">
          <form #statusUpdate="ngForm" (ngSubmit)="updateStatus(statusUpdate)">
            <div class="modal-btn modal-header modal-buttons-header sub-modal-header">
              <img src="../../../assets/theme1/status.png">
              <h5 class="modal-title" id="updateStatusLabel">Edit User Status</h5>
            </div>
            <div class="modal-body d-flex flex-wrap justify-content-center">
              <div class="col-8 mt-2 mb-2 select-box">
                <select id="employee_type" [ngModel]="(userData != null) ? userData.employee_type : null"
                  name="employee_type" data-toggle="dropdown"
                  class="dropdown-toggle checks-dropdown form-control pl-4 selectpicker" ngModel
                  #employee_type="ngModel" required>
                  <option value="null" disabled selected>Select Employee Status</option>
                  @for (status of statuses; let i = $index; track status) {
                  <option [value]="status">{{ status }}</option>
                  }
                </select>

              </div>

            </div>
            <div class="modal-footer sub-modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>
        </div>


      </div>
    </div>



    <!-- delete modal -->
    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" >
          <div class="modal-header sub-modal-header deleteModal-head" >
            <h5 class="modal-title" id="exampleModalLongTitle">Confirmation</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body deleteModal-body">
            <p>Are you sure you want to <b>Delete </b> this User?</p>
          </div>
          <div class="modal-footer sub-modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          
            <button type="button" class="btn btn-danger" (click)="UserDelete()">Delete</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>